






















































import { defineComponent, computed, ref, getCurrentInstance } from '@vue/composition-api';
import { ChevronLeftIcon, UserIcon } from 'tdesign-icons-vue';
import switchOrg from '@/renderer/components/user/components/switchOrg.vue';
import userConfigHandler from '@/renderer/components/user/compositions/userConfigHandler';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { phoneCompose } from '@/renderer/scripts/utils/tools';

export default defineComponent({
  components: {
    ChevronLeftIcon,
    UserIcon,
    switchOrg,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const showSwitchOrg = ref(false);
    const routeName = computed(() => vm.$route.name);
    const userAvatar = computed(() => {
      const { avatar } = store.getters.userBaseInfo;
      if (!avatar) return '';
      return avatar.includes('http') ? avatar : `${store.getters.protocol}:${avatar}`;
    });
    const userNickname = computed(() => store.getters.userBaseInfo.nickname);
    const userPhoneNumber = computed(() =>
      phoneCompose(store.getters.userBaseInfo.countryCode, store.getters.userBaseInfo.phoneNumber),
    );
    const { showSwitchOrgEntry } = userConfigHandler();
    const methods = {
      signOut() {
        context.emit('signOut');
      },
      openDesktop() {
        dispatchRouter({
          name: 'recentUse',
        });
        innerShow.value = false;
      },
    };

    // 展示时查询一下是否所属多个企业
    store.dispatch('getOrgList');
    return {
      innerShow,
      userAvatar,
      userNickname,
      userPhoneNumber,
      routeName,
      showSwitchOrg,
      showSwitchOrgEntry,
      ...methods,
    };
  },
});
